module.exports = __webpack_public_path__ + "img/AramKakayFalah.3bbafa0a.jpg";